/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

export type ContactScope = (typeof ContactScope)[keyof typeof ContactScope];

export const ContactScope = {
  universal: "universal",
  country: "country",
  site: "site",
} as const;
